import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { SalaryProfileReport } from "../../../components/Reports/SalaryProfileReport";

export interface ISalaryProfileReportSetupPage {}

export const SalaryProfileReportSetupPage: FC<ISalaryProfileReportSetupPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Salary Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<SalaryProfileReport />}
		/>
	);
};
